import * as React from 'react';

import { NotificationType } from './feature-service-types';
import { PopupNotificationList } from './components/popup';
import type { NotificationsProps } from './FeatureHubAppDefinition';
import type { ContentType } from './types';

function getNotificationsTypes(contentType: ContentType): NotificationType[] {
  switch (contentType) {
    case 'popup':
      return [
        NotificationType.POPUP_ERROR,
        NotificationType.POPUP_SUCCESS,
        NotificationType.POPUP_GENERIC,
      ];
    case 'sticky':
      return []; // TODO: implement when sticky notifications become relevant
    default:
      return [];
  }
}

export const Notifications: React.FunctionComponent<NotificationsProps> = (
  props,
): React.ReactElement | null => {
  const types = props?.contentType ? getNotificationsTypes(props?.contentType) : [];
  const [notifications, updateNotifications] = React.useState(
    props?.notificationService?.getNotifications(types),
  );

  React.useEffect(() => {
    const unsubscriber = props?.notificationService?.subscribe(() => {
      updateNotifications(props?.notificationService?.getNotifications(types));
    });

    return () => {
      unsubscriber?.unsubscribe();
    };
  }, [props?.notificationService]);

  const { contentType } = props;

  switch (contentType) {
    case 'popup':
      return <PopupNotificationList notifications={notifications || []} />;
    case 'sticky':
      return null; // TODO: implement when sticky notifications become relevant
    default:
      return null;
  }
};
